/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleListRequest {
    getFixupPrototypeFunction() { return RoleListRequest.fixupPrototype; }

    static newInstance(model: Partial<RoleListRequest>): RoleListRequest {
        let obj = Object.assign(new RoleListRequest(), model);
        RoleListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleListRequest>): RoleListRequest {
        if (!model) return null;
        return RoleListRequest.newInstance(<RoleListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleListRequest) {
        if (!obj) return;

        models.RoleListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleListRequest): boolean {
        Object.setPrototypeOf(obj, RoleListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.RoleFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.RoleSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.RoleSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.RoleFilters;

}
